<app-indicator-filter></app-indicator-filter>
<p class="mt-0 mb-3 text-sm text-color-secondary">
  Gewähltes Set:
  <strong class="text-color">{{ selectedSet?.name ?? '–' }}</strong>
</p>
<div>
  <p-listbox
    [options]="options()"
    [(ngModel)]="selectedSet"
    optionLabel="set.name"
    optionValue="set"
    optionDisabled="disabled"
    dataKey="_id"
    (onChange)="selectSet()"
    styleClass="w-full"
    emptyMessage="Kein Set passt zum Filter"
    [listStyle]="{ 'max-height': '30rem' }">
    <ng-template let-option pTemplate="item">
      <div class="w-full">
        <div class="flex align-items-center gap-2 text-lg pb-2">
          <i class="fas fa-ruler-combined"></i>
          <span>
            {{ option.set.name }}
          </span>
          @if (option.disabled) {
            <span class="text-xs font-normal text-color-secondary">
              (Teil der Auswahl – kann nicht Ziel sein)
            </span>
          }
          <p-badge
            class="ml-auto"
            *ngIf="units[option.set.unit]"
            [value]="
              units[option.set.unit].symbol || units[option.set.unit].name
            "></p-badge>
        </div>
        <div class="flex align-items-center gap-2 pb-2">
          <p-tag
            [rounded]="true"
            icon="fas fa-folder"
            styleClass="p-tag-category"
            [value]="categoryStore.getPathById(option.set.category)"></p-tag>
        </div>
        <app-tag-list
          styleClass="text-xs"
          *ngIf="option.set.tags?.length"
          [tagIds]="option.set.tags"></app-tag-list>
      </div>
    </ng-template>
  </p-listbox>
</div>
<p-divider></p-divider>
